import React from "react";
import "./i18n";
// import ReactDOM from "react-dom";
import {createRoot} from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import store from "redux/store/index";
import { msalConfig } from './authConfig';
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const msalInstance = new PublicClientApplication(msalConfig); 

msalInstance.initialize().then(()=>{

  console.log(msalInstance.getAllAccounts());
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }
  
  // Listen for sign-in event and set active account
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        // let accessToken = event.payload.accessToken;

        msalInstance.setActiveAccount(account);
        console.log(account);
    }
  });
})

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <App/>
    </MsalProvider>
  </Provider>
);
